import styles from './styles.module.scss';

const Text = ({ children = '', className = '', text = children }) => (
    <p className={`${className} ${styles.text}`}>{text}</p>
);

export default Text;
